/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import AppointmentActions from 'DesignSystem/AppointmentActions/index'
import FloatingPortal from 'DesignSystem/FloatingPortal/react'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/PatientOverlay/Content/Content/Appointments/TabContent/Content/AppointmentsList/Content/Appointment/EditAction/Content/Content",
  innerRef,
  top,
  left
  
}) {
  let flow = fromFlow.useFlow()
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let dtSpaceMs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ms'
        })
let dtSpaceLs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.ls'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let eventAppointmentBooking0IdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.[0]._id',
})
let eventAppointmentBooking0IdValueData1 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.[0].id',
})
let eventAppointmentBooking0StateValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.[0].state',
})
let eventAppointmentBooking0ConfirmationStatusValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.[0].confirmation_status',
})
let eventAppointmentBooking0StartTimeValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.[0].start_time',
})
let eventAppointmentBooking0EndTimeValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.[0].end_time',
})
let eventAppointmentBooking0ChairResourceOrganizationIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.[0].chair.resource.organization.id',
})
let eventAppointmentBooking0ChairResourceOrganizationIdValueData1 = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.[0].chair.resource.organization._id',
})
let eventAppointmentBooking0ChairResourceOrganizationNameValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.[0].chair.resource.organization.name',
})
let eventAppointmentBooking0AssistantIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.[0].assistant_id',
})
let eventAppointmentBooking0ProviderIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.[0].provider_id',
})
let eventAppointmentBooking0ChairIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.[0].chair_id',
})
let eventAppointmentIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment._id',
})
let eventAppointmentHasNotesValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.has_notes',
})
let patientIdValueData = fromData.useDataValue({ viewPath,
context: 'patient',
path: '_id',
})
let eventAppointmentBooking0ChairResourceOrganizationTimeZoneIdValueData = fromData.useDataValue({ viewPath,
context: 'event',
path: 'appointment.booking.[0].chair.resource.organization.time_zone_id',
})
  return (<React.Fragment
>
<FloatingPortal
  viewPath={`${viewPath}/FloatingPortal`}
>
{childProps => (
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 ref={innerRef}
 style={{'--t-1-Z1Yf8zk': typeof top === 'number' ? `${top}px` : top,'--l-2-Z1Yf8zk': typeof left === 'number' ? `${left}px` : left,'--bc-3-Z1Yf8zk': dtColorsWhite,'--bc-4-Z1Yf8zk': dtColorsNeutral200,'--btlr-5-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-6-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bblr-7-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-8-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-9-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--pb-10-Z1Yf8zk': typeof dtSpaceMs === 'number' ? `${dtSpaceMs}px` : dtSpaceMs,'--pt-11-Z1Yf8zk': typeof dtSpaceLs === 'number' ? `${dtSpaceLs}px` : dtSpaceLs,'--pr-12-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs,'--g-13-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block new-shadow ${styles.Vertical}`}
>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 style={{'--pl-9-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-12-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--mb-14-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical1}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Edit appointment"
 color={dtColorsNeutral500}
 weight="medium"
/>
</div>
<AppointmentActions
  viewPath={`${viewPath}/AppointmentActions`}
 data="event.appointment.booking.[0]._id"
 appointment_booking_id={eventAppointmentBooking0IdValueData}
 data="event.appointment.booking.[0].id"
 appointment_booking_vaxiom_id={eventAppointmentBooking0IdValueData1}
 data="event.appointment.booking.[0].state"
 appointment_booking_state={eventAppointmentBooking0StateValueData}
 data="event.appointment.booking.[0].confirmation_status"
 appointment_booking_confirmation_status={eventAppointmentBooking0ConfirmationStatusValueData}
 data="event.appointment.booking.[0].start_time"
 appointment_booking_start={eventAppointmentBooking0StartTimeValueData}
 data="event.appointment.booking.[0].end_time"
 appointment_booking_end={eventAppointmentBooking0EndTimeValueData}
 data="event.appointment.booking.[0].chair.resource.organization.id"
 appointment_booking_vaxiom_location_id={eventAppointmentBooking0ChairResourceOrganizationIdValueData}
 data="event.appointment.booking.[0].chair.resource.organization._id"
 appointment_booking_location_id={eventAppointmentBooking0ChairResourceOrganizationIdValueData1}
 data="event.appointment.booking.[0].chair.resource.organization.name"
 appointment_booking_location_name={eventAppointmentBooking0ChairResourceOrganizationNameValueData}
 data="event.appointment.booking.[0].assistant_id"
 appointment_booking_assistant_id={eventAppointmentBooking0AssistantIdValueData}
 data="event.appointment.booking.[0].provider_id"
 appointment_booking_provider_id={eventAppointmentBooking0ProviderIdValueData}
 data="event.appointment.booking.[0].chair_id"
 appointment_booking_chair_id={eventAppointmentBooking0ChairIdValueData}
 is_patient_overlay_call={true}
 data="event.appointment._id"
 appointment_id={eventAppointmentIdValueData}
 data="event.appointment.has_notes"
 appointment_has_notes={eventAppointmentHasNotesValueData}
 data="patient._id"
 patient_id={patientIdValueData}
 onClickComplete={() => setFlowTo(fromFlow.normalizePath(viewPath, '../../No'))}
 isSelectedComplete={flow.has(fromFlow.normalizePath(viewPath, '../../No'))}
 data="event.appointment.booking.[0].chair.resource.organization.time_zone_id"
 time_zone_id={eventAppointmentBooking0ChairResourceOrganizationTimeZoneIdValueData}
/>
</div>
)}
</FloatingPortal>
{children}
</React.Fragment>)
}